import { datadogRum } from "@datadog/browser-rum";
import type { Restaurant } from "api-types";
import type { User } from "firebase/auth";

/*
Monitoring Configurations to help us track user sessions and actions. This uses Datadog's RUM (Real User Monitoring) library.

Docs: https://docs.datadoghq.com/real_user_monitoring/browser/modifying_data_and_context/?tab=npm#user-session
*/

export const onAuthChange = (user: User | null) => {
  if (user) {
    datadogRum.setUser({
      id: user.uid,
      name: user.displayName || "",
      email: user.email || "",
    });
  } else {
    datadogRum.clearUser();
  }
};

export const onRestaurantSelected: (restaurant: Restaurant) => void = (
  restaurant
) => {
  datadogRum.setUserProperty("restUuidSelected", restaurant.uuid);
  datadogRum.setUserProperty("restNameSelected", restaurant.name);
};
